/* eslint-disable */
import * as React from "react";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";
import { FaArrowLeft, FaMinus } from "react-icons/fa";
import { useState, useEffect } from "react";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "./SideBar";
import AccountList from "./AccountList";
import { Link } from "react-router-dom";
import HeaderName from "./HeaderName";
import { useSelector } from "react-redux";
import { API_URL } from "../../api";
import RedStar from "../common/RedStar";

export default function BankInfoDialog(props) {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  const [code, setCode] = useState("");
  const [accountingTypes, setAccountingTypes] = useState("");
  const [headingList, setHeadingList] = useState([]);
  const [heading, setHeading] = useState("");
  const [subHeading, setSubHeading] = useState("");
  const [accType, setAccType] = useState([]);

  const [amount, setAmount] = useState("");

  const [relatedCurrency, setRelatedCurrency] = useState("");
  const [upWork, setUpWork] = useState(false);
  const [flag, setFlag] = useState(false);
  const [upFlag, setUpFlag] = useState(true);
  const [upCode, setUpCode] = useState("");
  const [upSub, setUpSub] = useState("");
  const [upBal, setUpBal] = useState("");
  const [upCur, setUpCur] = useState("");
  const [reHead, setReHead] = useState("");
  const [reHeadName, setReHeadName] = useState("");
  const [reHeadId, setReHeadId] = useState("");
  const [reTypeName, setReTypeName] = useState("");
  const [reTypeId, setReTypeId] = useState("");
  const [natureType, setNatureType] = useState("");
  const [type, setType] = useState("");
  const [currencies, setCurrencies] = useState([]);

  const Id = useLocation().pathname.split("/")[2];

  const [errors, setErrors] = useState({
    upCode: "",
    reTypeId: "",
    reHeadId: "",
    upSub: "",
    upBal: "",
    upCur: "",
    natureType: "",
  });

  console.log(upCode);

  const AccountUpdate = () => {
    const require = {};

    if (!upCode) {
      require.upCode = "Account Code is required";
    }
    if (!reTypeId) {
      require.reqTypeId = "Account Type is required";
    }
    if (!reHeadId) {
      require.reHeadId = "Heading is required";
    }

    if (!upSub) {
      require.upSub = "Sub Heading is required";
    }
    if (!upBal) {
      require.upBal = "Balance is required";
    }
    if (!upCur) {
      require.upCur = "Currency is required";
    }
    if (!natureType) {
      require.natureType = "AccountNature Type is required";
    }
    if (!type) {
      require.type = "Type is required";
    }

    if (Object.keys(require).length > 0) {
      setErrors(require);
      return;
    }

    setErrors({
      upCode: "",
      reTypeId: "",
      reHeadId: "",
      upSub: "",
      upBal: "",
      upCur: "",
      natureType: "",
    });

    const currencyCode = currencies.find((item) => item._id === upCur).code;
    const data = {
      id: Id,
      code: upCode,
      name: upSub,
      relatedType: reTypeId,
      relatedHeader: reHeadId,
      subHeader: upSub,
      amount: upBal,
      openingBalance: upBal,
      generalFlag: upFlag,
      relatedCurrency: currencyCode,
      relatedCurrencyId: upCur,
      carryForWork: upWork,
      accountNature: natureType,
      type,
    };
    if (reTypeId) {
      data.relatedType = reTypeId;
    } else {
      data.relatedType = reType;
    }
    if (reHeadId) {
      data.relatedHeader = reHeadId;
    } else {
      data.relatedHeader = reHead;
    }

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    // alert(JSON.stringify(data))
    api
      .put("accounting-list", data, config)
      .then(function (response) {
        // alert('success')
        Swal.fire({
          title: "Successful!",
          text: "Account Data Updated Successfully!",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
        window.location.reload();
        // props.setAccountLists([...props.accountLists, response.data.data])
        // const index = props.accountLists.findIndex(
        //   item => item._id === props.id
        // )
        // let arr = [...props.accountLists]
        // arr[index] = {
        //   ...arr[index],
        //   ...response.data.data
        // }
        // props.setAccountLists(arr)
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const handleHeading = async (event) => {
    setHeading(event);
    // console.log(heading, headingList)
  };

  const handleAccountHeader = async (event) => {
    setAccountingTypes(event);
    // setReType(event)
    // console.log(accountingTypes)

    const res = await api.get(`account-headers/related/${event}`);
    console.log(res.data.data, "Head");
    setHeadingList(res.data.data);
    setFlag(true);
    // console.log(headingList, 'heading')
  };
  useEffect(() => {
    const getAccountingType = async () => {
      try {
        const res = await api.get("account-types");
        setAccType(res.data.list);
      } catch (err) {}
    };

    const getCurrencies = async () => {
      try {
        const res = await api.get("currencies/filter-options");
        setCurrencies(res.data.data);
      } catch (err) {}
    };

    const getAccount = async () => {
      try {
        console.log(Id, "Id");
        const res = await api.get("accounting-list/" + Id);
        // console.log(res.data.data)
        setUpCode(res.data.data[0].code);
        // console.log(res.data.data[0].code)

        setUpSub(res.data.data[0].subHeader);
        setUpBal(res.data.data[0].amount);
        setUpCur(res.data.data[0].relatedCurrencyId);

        setReHeadName(res.data.data[0].relatedHeader.name);
        setReHeadId(res.data.data[0].relatedHeader._id);
        setReTypeName(res.data.data[0].relatedType.name);
        setReTypeId(res.data.data[0].relatedType._id);
        setNatureType(
          res.data.data[0].accountNature ? res.data.data[0].accountNature : "",
        );
        setType(res.data.data[0].type);
      } catch (err) {}
    };

    getCurrencies();
    getAccountingType();
    getAccount();
  }, []);

  return (
    <>
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className="wrapper">
        {/* <!-- Content Wrapper. Contains page content --> */}
        <div>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row ">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/account_list">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Account List</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section class="content px-4" style={{ paddingBottom: "1.5rem" }}>
            <div class="container card px-3 py-3">
              {/* <!-- Small boxes (Stat box) --> */}

              <form action="" method="post">
                {/* @csrf */}
                <div class="modal-body">
                  <div class="form-group">
                    <label for="name">
                      Account Code <RedStar />
                    </label>
                    <input
                      type="text"
                      class="form-control border border-info"
                      name="acc_code"
                      id="acc_code"
                      value={upCode}
                      onChange={(e) => setUpCode(e.target.value)}
                    />
                    {errors?.upCode && (
                      <div className="text-danger">{errors?.upCode}</div>
                    )}
                  </div>
                  {/* <div class="form-group">
                <label for="name">Account Name</label>
                <input
                  type="text"
                  class="form-control border-info"
                  name="acc_name"
                  id="acc_name"
                  placeholder="eg. Revenue Account"
                  onChange={(e) => setName(e.target.value)}
                />
              </div> */}

                  <div class="form-group">
                    <label for="name">
                      Account Type <RedStar />
                    </label>
                    <select
                      class="custom-select border-info"
                      name="account_type_id"
                      onChange={(e) => {
                        handleAccountHeader(e.target.value);
                        setReTypeId(e.target.value);
                      }}
                    >
                      <option value={reTypeId}>{reTypeName}</option>
                      {accType.map((option) => (
                        <option value={option._id}>{option.name}</option>
                      ))}
                    </select>
                    {errors?.reTypeId && (
                      <div className="text-danger">{errors?.reTypeId}</div>
                    )}
                  </div>
                  {reHeadName && (
                    <div class="form-group">
                      <label for="name">
                        Heading <RedStar />
                      </label>
                      <select
                        class="custom-select border-info"
                        name="account_type_id"
                        onChange={(e) => {
                          handleHeading(e.target.value);
                          setReHeadId(e.target.value);
                        }}
                      >
                        <option value={reHeadId}>{reHeadName}</option>
                        {headingList.map((option) => (
                          <option value={option._id}>{option.name}</option>
                        ))}
                      </select>
                      {errors?.reHeadId && (
                        <div className="text-danger">{errors?.reHeadId}</div>
                      )}
                    </div>
                  )}
                  <div class="form-group">
                    <label for="name">
                      Sub Heading <RedStar />
                    </label>

                    <input
                      type="text"
                      name="sub_head"
                      className="form-control border-info"
                      id=""
                      value={upSub}
                      onChange={(e) => setUpSub(e.target.value)}
                    />
                    {errors?.upSub && (
                      <div className="text-danger">{errors?.upSub}</div>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="name">
                      Balance <RedStar />
                    </label>
                    <input
                      type="text"
                      class="form-control border-info"
                      name="balance"
                      value={upBal}
                      onChange={(e) => setUpBal(e.target.value)}
                    />
                    {errors?.upBal && (
                      <div className="text-danger">{errors?.upBal}</div>
                    )}
                  </div>
                  <div className="form-group mt-3">
                    <label>
                      Currency <RedStar />
                    </label>

                    <select
                      className="form-control"
                      name="bank_acc"
                      id="bank_acc"
                      onChange={(e) => setUpCur(e.target.value)}
                      value={upCur}
                    >
                      <option hidden>Select Currency</option>
                      {currencies.length > 0 &&
                        currencies.map((currency) => (
                          <option value={currency?._id}>
                            {currency?.code}
                          </option>
                        ))}
                    </select>

                    {errors?.upCur && (
                      <div className="text-danger">{errors?.upCur}</div>
                    )}
                  </div>
                  <div className="form-group mt-3">
                    <label>
                      Type <RedStar />
                    </label>

                    <select
                      className="form-control"
                      name="bank_acc"
                      id="bank_acc"
                      onChange={(e) => setNatureType(e.target.value)}
                    >
                      <option value={natureType} hidden>
                        {natureType}
                      </option>

                      <option value="Credit">Credit</option>
                      <option value="Debit">Debit</option>
                    </select>
                    {errors?.natureType && (
                      <div className="text-danger">{errors?.natureType}</div>
                    )}
                  </div>
                  <div className="form-group mt-3">
                    <label>
                      Type <RedStar />
                    </label>

                    <select
                      className="form-control"
                      name="bank_acc"
                      id="bank_acc"
                      onChange={(e) => setType(e.target.value)}
                      value={type}
                    >
                      <option value="Cash">Cash</option>
                      <option value="Bank">Bank</option>
                    </select>
                    {errors?.type && (
                      <div className="text-danger">{errors?.type}</div>
                    )}
                  </div>

                  {/* <div class='form-group'>
                    <label for='name'>General Flag</label>
                    <div class='row'>
                      <div class='col-md-6'>
                        <div class='form-check form-check-inline'>
                          <input
                            class='form-check-input'
                            type='radio'
                            name='yes_no'
                            id='yes'
                            onChange={e => setUpFlag(true)}
                          />
                          <label class='form-check-label text-info' for='yes'>
                            Yes
                          </label>
                        </div>
                      </div>
                      <div class='col-md-6'>
                        <div class='form-check form-check-inline'>
                          <input
                            class='form-check-input'
                            type='radio'
                            name='yes_no'
                            id='no'
                            onChange={e => setUpFlag(false)}
                          />
                          <label class='form-check-label text-info' for='no'>
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class='form-group'>
                    <label for='name'>Carry Forward</label>
                    <div class='row'>
                      <div class='col-md-6'>
                        <div class='form-check form-check-inline'>
                          <input
                            class='form-check-input'
                            type='radio'
                            name='no_yes'
                            id='yes1'
                            onclick='show_project()'
                            onChange={e => setUpWork(true)}
                          />
                          <label class='form-check-label text-info' for='bank'>
                            Yes
                          </label>
                        </div>
                      </div>
                      <div class='col-md-6'>
                        <div class='form-check form-check-inline'>
                          <input
                            class='form-check-input'
                            type='radio'
                            name='no_yes'
                            id='no1'
                            onclick='hide_project()'
                            onChange={e => setUpWork(false)}
                          />
                          <label class='form-check-label text-info' for='cash'>
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <Button class="btn btn-primary" onClick={AccountUpdate}>
                    Update
                  </Button>
                </div>
              </form>

              {/* <!-- /.row (main row) --> */}
            </div>
          </section>
          {/* <!-- /.content --> */}
        </div>
      </div>

      {/* <!-- /.content-wrapper --> */}

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>
      {/* <!-- /.control-sidebar --> */}
    </>
  );
}
// phyo
//maymyat
